var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuReferralOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1640_38115)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49712 18.6174C4.83374 18.6174 3.48535 20.0055 3.48535 21.7181V26.2273C3.48535 27.8922 4.74353 29.2952 6.35927 29.3692C8.08522 29.4483 9.50865 28.031 9.50865 26.2716V21.7178C9.50865 20.0055 8.16027 18.6174 6.49712 18.6174ZM15.1607 13.9453C13.4976 13.9453 12.1489 15.3334 12.1489 17.0457V26.272C12.1489 27.9842 13.4972 29.3723 15.1603 29.3723C16.8235 29.3723 18.1721 27.9842 18.1721 26.272V17.0457C18.1721 15.3334 16.8238 13.9453 15.1607 13.9453ZM23.8237 8.59375C22.1606 8.59375 20.8125 9.9817 20.8125 11.6938V26.2714C20.8125 27.9839 22.161 29.3722 23.8244 29.3722C25.4874 29.3722 26.8356 27.9842 26.8356 26.2721V11.6946C26.8356 9.98207 25.4871 8.59375 23.8237 8.59375Z",
    fill: "url(#paint0_linear_1640_38115)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5386 24.0151H3.87796C1.73626 24.0151 0 25.8027 0 28.0076C0 30.2125 1.73626 32.0001 3.87796 32.0001H26.122C28.2637 32.0001 30 30.2125 30 28.0076V27.5787C30 25.6105 28.4503 24.0151 26.5386 24.0151ZM4.96288 16.603L15.9729 9.7438L17.2573 11.3196C17.6948 11.8564 18.5286 11.7274 18.7936 11.0821L22.8091 1.30363C23.0984 0.599227 22.4908 -0.146239 21.7667 0.0247737L11.7158 2.39823C11.0525 2.55489 10.7844 3.37787 11.2219 3.91463L12.5061 5.49044L4.03291 15.4622C3.48233 16.1102 4.24752 17.0487 4.96288 16.603Z",
    fill: "url(#paint1_linear_1640_38115)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1640_38115",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5386 24.0151H3.87796C1.73626 24.0151 0 25.8027 0 28.0076C0 30.2125 1.73626 32.0001 3.87796 32.0001H26.122C28.2637 32.0001 30 30.2125 30 28.0076V27.5787C30 25.6105 28.4503 24.0151 26.5386 24.0151ZM4.96288 16.603L15.9729 9.7438L17.2573 11.3196C17.6948 11.8564 18.5286 11.7274 18.7936 11.0821L22.8091 1.30363C23.0984 0.599227 22.4908 -0.146239 21.7667 0.0247737L11.7158 2.39823C11.0525 2.55489 10.7844 3.37787 11.2219 3.91463L12.5061 5.49044L4.03291 15.4622C3.48233 16.1102 4.24752 17.0487 4.96288 16.603Z",
    fill: "url(#paint2_linear_1640_38115)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1640_38115)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.93,
    filter: "url(#filter0_f_1640_38115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49712 18.6174C4.83374 18.6174 3.48535 20.0055 3.48535 21.7181V26.2273C3.48535 27.8922 4.74353 29.2952 6.35927 29.3692C8.08522 29.4483 9.50865 28.031 9.50865 26.2716V21.7178C9.50865 20.0055 8.16027 18.6174 6.49712 18.6174ZM15.1607 13.9453C13.4976 13.9453 12.1489 15.3334 12.1489 17.0457V26.272C12.1489 27.9842 13.4972 29.3723 15.1603 29.3723C16.8235 29.3723 18.1721 27.9842 18.1721 26.272V17.0457C18.1721 15.3334 16.8238 13.9453 15.1607 13.9453ZM23.8237 8.59375C22.1606 8.59375 20.8125 9.9817 20.8125 11.6938V26.2714C20.8125 27.9839 22.161 29.3722 23.8244 29.3722C25.4874 29.3722 26.8356 27.9842 26.8356 26.2721V11.6946C26.8356 9.98207 25.4871 8.59375 23.8237 8.59375Z",
    fill: "url(#paint3_linear_1640_38115)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1640_38115",
    x: 1.48535,
    y: 6.59375,
    width: 27.3501,
    height: 24.7773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1640_38115"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1640_38115",
    x1: 85.1162,
    y1: -48.0262,
    x2: -54.6941,
    y2: 87.7743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1640_38115",
    x1: 32.4245,
    y1: 10.4192,
    x2: -2.00187,
    y2: 27.2627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE1A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1640_38115",
    x1: 32.4245,
    y1: 10.4192,
    x2: -2.00187,
    y2: 27.2627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE1A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1640_38115",
    x1: 85.1162,
    y1: -48.0262,
    x2: -54.6941,
    y2: 87.7743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFDF2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1640_38115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuReferralOverview);
export default __webpack_public_path__ + "static/media/menu-referral-overview.2f5414c4c6f7b76209dd1791a633956c.svg";
export { ForwardRef as ReactComponent };